export const ACCOUNTING_WORK_EN = {
    // ── #91: master data edited in place ──
    'screen.accounting.accounts.action.edit': 'Edit',
    'screen.accounting.accounts.action.change_code': 'Change code or type',
    'screen.accounting.fiscal_years.action.edit': 'Edit',
    'screen.accounting.fiscal_years.action.edit.field.days.help': 'The days change only while no entry falls in the year.',
    'screen.accounting.periods.action.edit': 'Edit',
    'screen.accounting.periods.action.edit.field.name_en': 'Name (English)',
    'screen.accounting.periods.action.edit.field.days.help': 'The days change only while no entry falls in the period, and stay inside its year.',
    'screen.accounting.posting_rules.action.edit': 'Edit',
    'screen.accounting.tax_rules.action.edit': 'Edit',
    'screen.accounting.tax_codes.action.create': 'New tax code',
    'screen.accounting.tax_codes.action.edit': 'Edit',
    'screen.accounting.tax_codes.action.rename': 'Rename',
    'screen.accounting.tax_codes.action.create.section.code': 'The code',
    'screen.accounting.tax_codes.action.create.section.rules': 'How it applies',
    'screen.accounting.tax_codes.action.create.field.code': 'Code',
    'screen.accounting.tax_codes.action.create.field.code.help': 'Your own code, such as SA-S-15-GOODS. Letters, digits, dot, dash.',
    'screen.accounting.tax_codes.action.create.field.name_ar': 'Name (Arabic)',
    'screen.accounting.tax_codes.action.create.field.name_en': 'Name (English)',
    'screen.accounting.tax_codes.action.create.field.tax_type': 'Type',
    'screen.accounting.tax_codes.action.create.field.tax_type.help': 'Its ZATCA category follows from the type: standard S, zero-rated Z, exempt E, out of scope O. Withholding is not on an e-invoice.',
    'screen.accounting.tax_codes.action.create.field.rate': 'Rate (%)',
    'screen.accounting.tax_codes.action.create.field.exemption_reason_code': 'Exemption reason',
    'screen.accounting.tax_codes.action.create.field.exemption_reason_code.help': 'The authority\'s reason, which a zero-rated or exempt code must carry.',
    'screen.accounting.tax_codes.action.create.field.deductible': 'Input VAT',
    'screen.accounting.tax_codes.action.create.field.valid_from': 'Valid from',
    'screen.accounting.tax_codes.action.create.field.valid_to': 'Valid to',
    'screen.accounting.tax_codes.action.create.field.tax_account_id': 'Tax account',
    'screen.accounting.tax_codes.action.create.field.tax_account_id.help': 'Where a standard or withholding code posts its tax. A zero-rated, exempt or out-of-scope code books none and takes none.',
    'screen.accounting.tax_codes.column.origin': 'Source',
    'screen.accounting.tax_codes.column.zatca_category': 'ZATCA category',
    'value.origin.pack': 'Tax pack',
    'value.origin.workspace': 'Ours',
    'value.exemption_reason_code.VATEX-SA-29': 'VATEX-SA-29 · Financial services (Art. 29)',
    'value.exemption_reason_code.VATEX-SA-29-7': 'VATEX-SA-29-7 · Life insurance (Art. 29)',
    'value.exemption_reason_code.VATEX-SA-30': 'VATEX-SA-30 · Exempt supplies under Art. 30',
    'value.exemption_reason_code.VATEX-SA-32': 'VATEX-SA-32 · Export of goods',
    'value.exemption_reason_code.VATEX-SA-33': 'VATEX-SA-33 · Export of services',
    'value.exemption_reason_code.VATEX-SA-34-1': 'VATEX-SA-34-1 · International transport of goods',
    'value.exemption_reason_code.VATEX-SA-34-2': 'VATEX-SA-34-2 · International transport of passengers',
    'value.exemption_reason_code.VATEX-SA-34-3': 'VATEX-SA-34-3 · Services incidental to international passenger transport',
    'value.exemption_reason_code.VATEX-SA-34-4': 'VATEX-SA-34-4 · Supply of a qualifying means of transport',
    'value.exemption_reason_code.VATEX-SA-34-5': 'VATEX-SA-34-5 · Services relating to transport of goods or passengers',
    'value.exemption_reason_code.VATEX-SA-35': 'VATEX-SA-35 · Medicines and medical equipment',
    'value.exemption_reason_code.VATEX-SA-36': 'VATEX-SA-36 · Qualifying metals',
    'value.exemption_reason_code.VATEX-SA-EDU': 'VATEX-SA-EDU · Private education to citizens',
    'value.exemption_reason_code.VATEX-SA-HEA': 'VATEX-SA-HEA · Private healthcare to citizens',
    'value.exemption_reason_code.VATEX-SA-MLTRY': 'VATEX-SA-MLTRY · Qualified military goods',
    'value.deductible.full': 'Deductible',
    'value.deductible.none': 'Not deductible',
    'screen.einvoicing.sellers.action.edit': 'Edit',
    'screen.einvoicing.sellers.action.edit.field.vat_number.help': 'Changes only while nothing was issued under this seller\'s branch.',
    'screen.einvoicing.devices.action.rename': 'Rename',
    'change.field.posting_rule.used_at': 'First used',
    'change.field.tax_rule.used_at': 'First used',
    'change.field.tax_code.origin': 'Source',
    // ── #97: the invoice names its quotation; convert opens the editor ──
    'screen.invoicing.documents.column.quotation_number': 'From quotation',
    'screen.invoicing.quotation_convert.title': 'Invoice from a quotation',
    'screen.invoicing.quotation_convert.lede': 'The quotation becomes an invoice draft with its customer and lines, and the draft opens here to be checked, saved and issued.',
    'editor.quotationConvert.ask': 'Quotation {number} to {party}, {total} {currency}: make it an invoice draft? Nothing is issued until you issue the draft.',
    'editor.quotationConvert.action': 'Make the invoice draft',
    'editor.quotationConvert.made': 'The invoice draft is made from the quotation. Check it, save it, and issue it when it is right.',
    'editor.quotationConvert.already': 'This quotation was already made an invoice: here it is.',
    'editor.quotationConvert.none': 'No quotation was named.',
    'editor.quotationConvert.notQuotation': 'This document is not a quotation.',
    // ── #81: items from a file ──
    'import.problem.invoicing.tax_code_unknown': 'No tax code {code} is in use',
    'import.problem.invoicing.account_unknown': 'No account {code} is in use',
    'import.problem.invoicing.item.name_ar': 'The Arabic name is required: the authority reads the item in Arabic',
    'import.problem.invoicing.item.code': 'Another item in use already has this code',
    'import.problem.invoicing.item.item_type': 'The type is goods or service',
    'import.problem.invoicing.item.sales_price': 'The sales price is a number, zero or more',
    'import.problem.invoicing.item.purchase_price': 'The purchase price is a number, zero or more',
    'import.problem.invoicing.item.sales_tax_code_id': 'The sales tax code is a VAT code in use, not a withholding code',
    'import.problem.invoicing.item.purchase_tax_code_id': 'The purchase tax code is a VAT code in use, not a withholding code',
    'import.problem.invoicing.item.income_account_id': 'The sales account is an income account in use',
    'import.problem.invoicing.item.expense_account_id': 'The purchase account is an account in use',
    'change.field.item.import_id': 'Imported from file',
    'change.field.entry.import_id': 'Imported from file',
    // ── #95: what was built reached from a screen ──
    'screen.accounting.opening.action.paste': 'Paste balances',
    'screen.accounting.opening.lede.file': 'Opening balances post as one balanced general-journal entry: from a file (Import), whose every line is checked before anything is posted, or pasted as text. The contra is usually equity, 300000 in the starter chart.',
    'screen.invoicing.bank_reconciliation.action.import.file': 'Import statement',
    'screen.invoicing.bank_reconciliation.action.import.field.file': 'The bank\'s statement file',
    'screen.invoicing.bank_reconciliation.action.import.field.file.help': 'The CSV or Excel (.xlsx) your bank exports: its date, amount (or debit and credit) and description columns are found by their names, in Arabic or English.',
    'screen.invoicing.bank_reconciliation.action.import.field.csv.paste': 'Or paste its lines (CSV)',
    'screen.invoicing.export_batches.action.download': 'Download the file',
    'screen.accounting.ledger.column.deferrable': 'Can be spread',
    'screen.accounting.ledger.action.defer': 'Spread over months',
    'screen.accounting.ledger.action.defer.field.months': 'Over how many months',
    'screen.accounting.ledger.action.defer.field.months.help': 'An equal share at the end of each month, the halala left over on the last.',
    'screen.accounting.ledger.action.defer.field.deferral_account_id': 'Held on',
    'screen.accounting.ledger.action.defer.field.deferral_account_id.help': 'An asset for an expense paid ahead (prepaid), a liability for revenue received ahead (deferred revenue).',
    'screen.accounting.ledger.action.defer.field.starts_on': 'First month',
    'screen.accounting.ledger.action.defer.field.starts_on.help': 'Any day in the first month recognised. Empty: the month of the entry.',
    'screen.accounting.ledger.action.defer.field.reason': 'Reason',
    'screen.accounting.journal_book.title': 'Journal book',
    'screen.accounting.journal_book.lede': 'Every posted entry, line by line, in the order it was booked: by day, journal and number. Filter a journal or a range of days, and export it for the auditor.',
    'screen.accounting.journal_book.column.journal': 'Journal',
    'screen.accounting.journal_book.column.journal_name': 'Journal name',
    'screen.accounting.journal_book.journal': '{journal_code} · {journal_name}',
    'nav.accounting.journal_book': 'Journal book',
    'import.problem.accounting.account_unknown': 'No account {code} is in use',
    'import.problem.accounting.one_side': 'Each line has an amount in debit or in credit — not both, and not neither',
    'import.problem.accounting.one_date': 'The opening entry is on one day; the file names {n}',
    'import.problem.accounting.two_lines': 'An opening entry needs at least two lines',
    'import.problem.accounting.unbalanced': 'The file does not balance: debit {debit}, credit {credit}',
    'import.problem.accounting.one_journal': 'The opening entry goes through one journal; the file names several',
    'import.problem.accounting.journal_unknown': 'No journal {code} is in use',
    'import.problem.accounting.journal_general': 'Opening balances post only through a general journal',
    'import.problem.accounting.journal_choose': 'Name the general journal in the journal column: the workspace has none, or several',
    'import.problem.accounting.no_period': 'No period covers {date}',
    'import.problem.accounting.period_closed': 'The period of {date} is closed',
    'import.problem.accounting.locked': '{date} is on or before the lock date',
    // ── #87: the vendor bill as the supplier wrote it; #90: files in the editors ──
    'editor.vendor.supplierRef': 'Supplier\'s bill number',
    'editor.vendor.supplierRefHint': 'As printed on their bill: what their statement and any query will name it by.',
    'editor.vendor.twins': 'This vendor already has a bill numbered {ref}:',
    'editor.vendor.twinDraft': 'a draft',
    'editor.vendor.asWritten': 'As the supplier wrote it',
    'editor.vendor.asWrittenLede': 'A discount they gave on the whole bill, and the VAT per rate their bill states. VAT a few halalas off the lines\' (±1.00 a rate) is kept as they wrote it, and the difference posts to the rounding account.',
    'editor.vendor.documentDiscountHint': 'Taken off the whole bill; its VAT is reduced with it, and it posts to the earned-discount account.',
    'editor.vendor.vatAtRate': 'VAT at {rate}%',
    'editor.vendor.vatSame': 'As the lines compute it',
    'editor.vendor.vatDiffers': 'The lines give {computed}: {diff} to the rounding account',
    'editor.vendor.vatTooFar': 'The VAT at {rate}% may differ from the lines\' {computed} by 1.00 at most: check the lines instead.',
    'editor.need.supplierRef': 'the supplier\'s bill number',
    'editor.need.vatAsWritten': 'VAT at {rate}% within 1.00 of the lines\'',
    'editor.files.title': 'Files',
    'editor.files.lede': 'The supplier\'s bill, a delivery note: kept with the document. A PDF or an image opens beside the form.',
    'editor.files.choose': 'Attach a file',
    'editor.files.open': 'Open',
    'editor.files.close': 'Close',
    'editor.files.waiting': '{name} is added when the draft is saved',
    'invoicing.problem.supplier_ref': 'The supplier\'s bill number is required to issue a vendor bill',
    'screen.invoicing.vendor_bill.column.supplier_ref': 'Supplier\'s reference',
    'screen.invoicing.vendor_bill.column.tax_adjustment': 'VAT difference (as written)',
    'screen.invoicing.vendor_bill.column.supplier_ref_twin': 'Same reference on another bill',
    'screen.invoicing.vendor_bill.column.vat_as_written': 'VAT as written',
    'screen.invoicing.vendor_bill.alert.supplier_ref_twin': 'Another bill of this vendor carries the reference {supplier_ref}: is this one entered twice?',
    'screen.invoicing.vendor_bill.alert.vat_as_written': 'The VAT is as the supplier wrote it: {tax_adjustment} off the lines\' posts to the rounding account',
    'screen.invoicing.settings.action.set.field.purchase_discount_account_id': 'Earned discount account',
    'screen.invoicing.settings.action.set.field.purchase_discount_account_id.help': 'Where a discount a supplier gives on a whole bill posts. Its VAT is reduced with it.',
    'screen.invoicing.settings.action.set.field.rounding_account_id': 'Rounding account',
    'screen.invoicing.settings.action.set.field.rounding_account_id.help': 'Where the few halalas post when a bill\'s VAT is entered as the supplier wrote it rather than as its lines compute it (±1.00 a rate).',
    'change.field.document.supplier_ref': 'Supplier\'s reference',
    'change.field.document.tax_adjustments': 'VAT per rate as written',
    'change.field.document.tax_adjustment': 'VAT difference (as written)',
    'change.field.invoicing_settings.rounding_account_id': 'Rounding account',
    'change.field.invoicing_settings.purchase_discount_account_id': 'Earned discount account',
    // ── #88: the journal entry's lines, cost centres everywhere, templates ──
    'editor.line.party': 'Party',
    'editor.line.narration': 'Line narration',
    'editor.choices.dimensions': 'the cost centres',
    'editor.template.start': 'Start from a template',
    'editor.template.startHint': 'Its journal, words and lines; with its amounts, or its accounts for you to give amounts.',
    'editor.template.none': 'No template',
    'editor.template.withAmounts': 'With amounts',
    'editor.template.accountsOnly': 'Accounts only',
    'editor.template.keep': 'Keep as a template',
    'editor.template.keepLede': 'This entry\'s journal, words and lines, to be written again: with its amounts, or its accounts only.',
    'editor.template.name': 'Template name',
    'editor.template.keepAction': 'Keep the template',
    'editor.template.kept': 'Kept as «{name}»: start the next entry from it above.',
    'screen.accounting.entry_templates.title': 'Entry templates',
    'screen.accounting.entry_templates.lede': 'Entries kept to be written again: with their amounts, or their accounts only. Start one from the journal entry editor; save one from it the same way.',
    'screen.accounting.entry_templates.column.name_ar': 'Name',
    'screen.accounting.entry_templates.column.with_amounts': 'With amounts',
    'screen.accounting.entry_templates.column.line_count': 'Lines',
    'screen.accounting.entry_templates.column.created_at': 'Kept',
    'screen.accounting.entry_templates.action.create': 'New entry',
    'screen.accounting.entry_templates.action.retire': 'Retire',
    'screen.accounting.by_dimension.title': 'By cost centre',
    'screen.accounting.by_dimension.lede': 'The trial balance and the income statement by cost centre, project or any dimension, summed by month, value and account.',
    'screen.accounting.by_dimension.column.month': 'Month',
    'screen.accounting.by_dimension.column.dimension_name': 'Dimension',
    'screen.accounting.by_dimension.column.value_name': 'Value',
    'screen.accounting.by_dimension.column.value_code': 'Value code',
    'screen.accounting.by_dimension.column.presentation': 'Statement',
    'screen.accounting.by_dimension.column.result': 'To the result',
    'screen.accounting.by_dimension.value': '{value_code} · {value_name}',
    'nav.accounting.by_dimension': 'By cost centre',
    'nav.accounting.entry_templates': 'Entry templates',
    'change.field.document.dimension_id': 'Dimension',
    'change.field.document.value_id': 'Cost centre',
    'change.field.entry_template.name_ar': 'Name',
    'change.field.entry_template.name_en': 'Name (English)',
    'change.field.entry_template.journal_id': 'Journal',
    'change.field.entry_template.narration_ar': 'Narration',
    'change.field.entry_template.with_amounts': 'With amounts',
    'change.field.entry_template.lines': 'Lines',
    'change.field.entry_template.created_by': 'Kept by',
    'change.field.entry_template.retired_at': 'Retired',
    // ── #92: bank matching ──
    'editor.bank.file': 'The bank\'s statement file',
    'editor.bank.fileHint': 'CSV or Excel (.xlsx) as your bank exports it; its columns are found by their names, in Arabic or English.',
    'editor.bank.chooseFile': 'Choose the statement',
    'editor.bank.paste': 'Or paste its lines (CSV)',
    'editor.bank.lineMatched': 'matched',
    'editor.bank.lineLeft': '{left} left to match',
    'editor.bank.ruleSays': 'The rule «{rule}» gives this line to {account}.',
    'editor.bank.items': 'Match to items in the books',
    'editor.bank.itemsLede': 'Choose one item or several, whole or in part, until they come to {left}.',
    'editor.bank.noItems': 'No open item in the books goes this way on this account.',
    'editor.bank.partAmount': 'Amount matched',
    'editor.bank.gap': 'Chosen {chosen} of {left}: {gap} left',
    'editor.bank.differenceAccount': 'Close the difference to',
    'editor.bank.differenceHint': 'A line is closed at zero, or with what is left booked to an account — explicitly, with its reason.',
    'editor.bank.reason': 'Reason',
    'editor.bank.matchItems': 'Match',
    'editor.bank.matchWithDifference': 'Match and book the difference',
    'editor.bank.closed': 'The line is matched.',
    'editor.bank.partial': 'Matched in part: the rest of the line is still open.',
    'editor.bank.book': 'Book to an account',
    'editor.bank.bookLede': 'What no item explains — a fee, an expense, income: {left} booked against the account chosen.',
    'editor.bank.account': 'Account',
    'editor.bank.bookAction': 'Book the line',
    'editor.bank.booked': 'The line is booked and matched.',
    'editor.bank.receipt': 'A customer\'s receipt',
    'editor.bank.payment': 'A payment to a vendor',
    'editor.bank.paymentLede': 'A voucher for {left} through this bank on the line\'s day, matched to the line in the same step. Allocate it to documents from its page.',
    'editor.bank.party': 'Party',
    'editor.bank.makeReceipt': 'Make the receipt',
    'editor.bank.makePayment': 'Make the payment',
    'editor.bank.paymentMade': 'The voucher is made and the line matched.',
    'editor.bank.unmatch': 'Undo the match',
    'editor.bank.unmatchAction': 'Undo',
    'editor.bank.unmatched': 'Undone: the line and its items are open again.',
    'editor.bank.lastUnmatched': 'Last undone because: {reason}',
    'screen.invoicing.bank.unmatch.field.reason': 'Why',
    'screen.invoicing.bank_rules.title': 'Bank matching rules',
    'screen.invoicing.bank_rules.lede': 'A statement line matching a rule\'s words, amount and direction gets its account, proposed or booked on import; the first rule by priority wins.',
    'screen.invoicing.bank_rules.column.priority': 'Priority',
    'screen.invoicing.bank_rules.column.name_ar': 'Rule',
    'screen.invoicing.bank_rules.column.narration_contains': 'Words contain',
    'screen.invoicing.bank_rules.column.direction': 'Direction',
    'screen.invoicing.bank_rules.column.amount_min': 'From',
    'screen.invoicing.bank_rules.column.amount_max': 'To',
    'screen.invoicing.bank_rules.column.account_name': 'Account',
    'screen.invoicing.bank_rules.column.journal_code': 'Bank',
    'screen.invoicing.bank_rules.column.mode': 'Mode',
    'screen.invoicing.bank_rules.action.create': 'New rule',
    'screen.invoicing.bank_rules.action.retire': 'Retire',
    'screen.invoicing.bank_rules.action.create.field.name_ar': 'Name',
    'screen.invoicing.bank_rules.action.create.field.narration_contains': 'The line\'s words contain',
    'screen.invoicing.bank_rules.action.create.field.narration_contains.help': 'As the bank writes them, such as «رسوم» or «SADAD». Case aside.',
    'screen.invoicing.bank_rules.action.create.field.direction': 'Direction',
    'screen.invoicing.bank_rules.action.create.field.amount_min': 'Amount from',
    'screen.invoicing.bank_rules.action.create.field.amount_max': 'Amount to',
    'screen.invoicing.bank_rules.action.create.field.account_id': 'Account',
    'screen.invoicing.bank_rules.action.create.field.account_id.help': 'Where a line the rule meets is booked: a bank fee, an expense, income, a transfer account.',
    'screen.invoicing.bank_rules.action.create.field.mode': 'Mode',
    'screen.invoicing.bank_rules.action.create.field.mode.help': 'Suggest proposes the account on the line; apply books the line to it as the statement comes in.',
    'screen.invoicing.bank_rules.action.create.field.priority': 'Priority',
    'screen.invoicing.bank_rules.action.create.field.priority.help': 'The lower first, when two rules meet one line.',
    'value.bank_rule_direction.any': 'Either way',
    'value.bank_rule_direction.in': 'Money in',
    'value.bank_rule_direction.out': 'Money out',
    'value.bank_rule_mode.suggest': 'Suggest',
    'value.bank_rule_mode.apply': 'Apply',
    'nav.invoicing.bank_rules': 'Bank matching rules',
    'change.field.bank_statement.unmatch_reason': 'Why it was undone',
    'change.field.bank_statement.line_id': 'Statement line',
    'change.field.bank_statement.item_id': 'Item matched',
    'change.field.bank_statement.matched_by': 'Matched by',
    'change.field.bank_statement.unmatched_by': 'Undone by',
    'change.field.bank_statement.unmatched_at': 'Undone',
    'change.field.bank_rule.name_ar': 'Name',
    'change.field.bank_rule.journal_id': 'Bank',
    'change.field.bank_rule.direction': 'Direction',
    'change.field.bank_rule.narration_contains': 'Words contain',
    'change.field.bank_rule.amount_min': 'Amount from',
    'change.field.bank_rule.amount_max': 'Amount to',
    'change.field.bank_rule.account_id': 'Account',
    'change.field.bank_rule.party_id': 'Party',
    'change.field.bank_rule.mode': 'Mode',
    'change.field.bank_rule.priority': 'Priority',
    'change.field.bank_rule.created_by': 'Made by',
    'change.field.bank_rule.retired_at': 'Retired',
    // ── list pages: what an empty list means (list-standard §11, R6) ──
    'screen.accounting.accounts.empty': 'No accounts in the chart yet',
    'screen.accounting.accounts.empty.description': 'Add an account, or import the starter chart to begin from it.',
    'screen.accounting.dimension_values.empty': 'No dimension values yet',
    'screen.accounting.dimension_values.empty.description': 'Each value a line can be tagged with — a cost centre, a project — appears here under its dimension.',
    'screen.accounting.dimensions.empty': 'No dimensions yet',
    'screen.accounting.dimensions.empty.description': 'A dimension such as a cost centre or a project tags posted lines, so the reports can be read by it.',
    'screen.accounting.entries.empty': 'No journal entries yet',
    'screen.accounting.entries.empty.description': 'Every posted entry appears here with its number, date and narration.',
    'screen.accounting.entry_templates.empty': 'No entry templates yet',
    'screen.accounting.entry_templates.empty.description': 'Save an entry as a template from the journal entry editor to write it again.',
    'screen.accounting.fiscal_years.empty': 'No fiscal years yet',
    'screen.accounting.fiscal_years.empty.description': 'Create the fiscal year first; its periods are added under it.',
    'screen.accounting.journals.empty': 'No journals yet',
    'screen.accounting.journals.empty.description': 'Each journal numbers its own entries: sales, purchases, bank, cash or general.',
    'screen.accounting.periods.empty': 'No periods yet',
    'screen.accounting.periods.empty.description': 'A posting finds its period by its date, so every day of the fiscal year falls in one period.',
    'screen.accounting.posting_rules.empty': 'No posting rules yet',
    'screen.accounting.posting_rules.empty.description': 'A rule names the debit and credit accounts a kind of line posts to.',
    'screen.accounting.tax_codes.empty': 'No tax codes yet',
    'screen.accounting.tax_codes.empty.description': 'Import the VAT tax pack or add a code; each is enabled once a named person confirms it.',
    'screen.accounting.tax_rules.empty': 'No tax rules yet',
    'screen.accounting.tax_rules.empty.description': 'A rule picks a line\'s tax code by its kind, the buyer and where the supply goes.',
    'screen.einvoicing.devices.empty': 'No e-invoice devices yet',
    'screen.einvoicing.devices.empty.description': 'Each device signs and numbers the invoices of one branch and sales journal once it is onboarded.',
    'screen.einvoicing.sellers.empty': 'No e-invoice sellers yet',
    'screen.einvoicing.sellers.empty.description': 'The seller each e-invoice names: its legal name, VAT and CR numbers and national address, per branch.',
    'screen.invoicing.bank_rules.empty': 'No matching rules yet',
    'screen.invoicing.bank_rules.empty.description': 'A rule gives a recurring statement line — a bank charge, a rent — its account without matching it by hand.',
};
export const ACCOUNTING_WORK_AR = {
    // ── #91 ──
    'screen.accounting.accounts.action.edit': 'تعديل',
    'screen.accounting.accounts.action.change_code': 'تغيير الرمز أو النوع',
    'screen.accounting.fiscal_years.action.edit': 'تعديل',
    'screen.accounting.fiscal_years.action.edit.field.days.help': 'تتغيّر الأيام ما دام لم يُرحَّل في السنة قيد.',
    'screen.accounting.periods.action.edit': 'تعديل',
    'screen.accounting.periods.action.edit.field.name_en': 'الاسم (بالإنجليزية)',
    'screen.accounting.periods.action.edit.field.days.help': 'تتغيّر الأيام ما دام لم يُرحَّل في الفترة قيد، وتبقى داخل سنتها.',
    'screen.accounting.posting_rules.action.edit': 'تعديل',
    'screen.accounting.tax_rules.action.edit': 'تعديل',
    'screen.accounting.tax_codes.action.create': 'رمز ضريبة جديد',
    'screen.accounting.tax_codes.action.edit': 'تعديل',
    'screen.accounting.tax_codes.action.rename': 'إعادة التسمية',
    'screen.accounting.tax_codes.action.create.section.code': 'الرمز',
    'screen.accounting.tax_codes.action.create.section.rules': 'كيف يُطبَّق',
    'screen.accounting.tax_codes.action.create.field.code': 'الرمز',
    'screen.accounting.tax_codes.action.create.field.code.help': 'رمز من عندكم مثل SA-S-15-GOODS: حروف لاتينية وأرقام ونقطة وشرطة.',
    'screen.accounting.tax_codes.action.create.field.name_ar': 'الاسم (بالعربية)',
    'screen.accounting.tax_codes.action.create.field.name_en': 'الاسم (بالإنجليزية)',
    'screen.accounting.tax_codes.action.create.field.tax_type': 'النوع',
    'screen.accounting.tax_codes.action.create.field.tax_type.help': 'فئة هيئة الزكاة والضريبة تتبع النوع: قياسية S، صفرية Z، معفاة E، خارج النطاق O. وضريبة الاستقطاع لا تظهر في الفاتورة الإلكترونية.',
    'screen.accounting.tax_codes.action.create.field.rate': 'النسبة (٪)',
    'screen.accounting.tax_codes.action.create.field.exemption_reason_code': 'سبب الإعفاء',
    'screen.accounting.tax_codes.action.create.field.exemption_reason_code.help': 'سبب الهيئة الذي يحمله كل رمز صفري أو معفى.',
    'screen.accounting.tax_codes.action.create.field.deductible': 'ضريبة المدخلات',
    'screen.accounting.tax_codes.action.create.field.valid_from': 'سارٍ من',
    'screen.accounting.tax_codes.action.create.field.valid_to': 'سارٍ حتى',
    'screen.accounting.tax_codes.action.create.field.tax_account_id': 'حساب الضريبة',
    'screen.accounting.tax_codes.action.create.field.tax_account_id.help': 'الحساب الذي يُرحِّل إليه الرمز القياسي أو رمز ضريبة الاستقطاع ضريبته. والصفري والمعفى وخارج النطاق لا يُرحِّل ضريبة فلا يأخذ حسابًا.',
    'screen.accounting.tax_codes.column.origin': 'المصدر',
    'screen.accounting.tax_codes.column.zatca_category': 'فئة الهيئة',
    'value.origin.pack': 'حزمة الضرائب',
    'value.origin.workspace': 'من عندنا',
    'value.exemption_reason_code.VATEX-SA-29': 'VATEX-SA-29 · الخدمات المالية (المادة 29)',
    'value.exemption_reason_code.VATEX-SA-29-7': 'VATEX-SA-29-7 · التأمين على الحياة (المادة 29)',
    'value.exemption_reason_code.VATEX-SA-30': 'VATEX-SA-30 · التوريدات العقارية (المادة 30)',
    'value.exemption_reason_code.VATEX-SA-32': 'VATEX-SA-32 · تصدير السلع',
    'value.exemption_reason_code.VATEX-SA-33': 'VATEX-SA-33 · تصدير الخدمات',
    'value.exemption_reason_code.VATEX-SA-34-1': 'VATEX-SA-34-1 · النقل الدولي للسلع',
    'value.exemption_reason_code.VATEX-SA-34-2': 'VATEX-SA-34-2 · النقل الدولي للركاب',
    'value.exemption_reason_code.VATEX-SA-34-3': 'VATEX-SA-34-3 · خدمات مرتبطة بالنقل الدولي للركاب',
    'value.exemption_reason_code.VATEX-SA-34-4': 'VATEX-SA-34-4 · توريد وسائل نقل مؤهلة',
    'value.exemption_reason_code.VATEX-SA-34-5': 'VATEX-SA-34-5 · خدمات متصلة بنقل السلع أو الركاب',
    'value.exemption_reason_code.VATEX-SA-35': 'VATEX-SA-35 · الأدوية والمعدات الطبية',
    'value.exemption_reason_code.VATEX-SA-36': 'VATEX-SA-36 · المعادن المؤهلة',
    'value.exemption_reason_code.VATEX-SA-EDU': 'VATEX-SA-EDU · التعليم الخاص للمواطنين',
    'value.exemption_reason_code.VATEX-SA-HEA': 'VATEX-SA-HEA · الرعاية الصحية الخاصة للمواطنين',
    'value.exemption_reason_code.VATEX-SA-MLTRY': 'VATEX-SA-MLTRY · السلع العسكرية المؤهلة',
    'value.deductible.full': 'قابلة للخصم',
    'value.deductible.none': 'غير قابلة للخصم',
    'screen.einvoicing.sellers.action.edit': 'تعديل',
    'screen.einvoicing.sellers.action.edit.field.vat_number.help': 'يتغيّر ما دام لم يصدر شيء تحت فرع هذه المنشأة.',
    'screen.einvoicing.devices.action.rename': 'إعادة التسمية',
    'change.field.posting_rule.used_at': 'أول استعمال',
    'change.field.tax_rule.used_at': 'أول استعمال',
    'change.field.tax_code.origin': 'المصدر',
    // ── #97 ──
    'screen.invoicing.documents.column.quotation_number': 'من عرض السعر',
    'screen.invoicing.quotation_convert.title': 'فاتورة من عرض سعر',
    'screen.invoicing.quotation_convert.lede': 'يصير عرض السعر مسودة فاتورة بعميله وبنوده، وتُفتح المسودة هنا لتراجعها وتحفظها وتصدرها.',
    'editor.quotationConvert.ask': 'عرض السعر {number} إلى {party} بمبلغ {total} {currency}: هل تُنشأ منه مسودة فاتورة؟ لا يصدر شيء حتى تصدر المسودة.',
    'editor.quotationConvert.action': 'إنشاء مسودة الفاتورة',
    'editor.quotationConvert.made': 'أُنشئت مسودة الفاتورة من عرض السعر. راجعها واحفظها وأصدرها حين تكتمل.',
    'editor.quotationConvert.already': 'صار عرض السعر هذا فاتورة من قبل، وهذه هي.',
    'editor.quotationConvert.none': 'لم يُحدَّد عرض سعر.',
    'editor.quotationConvert.notQuotation': 'هذا المستند ليس عرض سعر.',
    // ── #81 ──
    'import.problem.invoicing.tax_code_unknown': 'لا رمز ضريبة مستعملًا بالرمز {code}',
    'import.problem.invoicing.account_unknown': 'لا حساب مستعملًا بالرمز {code}',
    'import.problem.invoicing.item.name_ar': 'الاسم بالعربية مطلوب: الهيئة تقرأ الصنف بالعربية',
    'import.problem.invoicing.item.code': 'رمز الصنف مستعمل لصنف آخر',
    'import.problem.invoicing.item.item_type': 'النوع سلعة أو خدمة',
    'import.problem.invoicing.item.sales_price': 'سعر البيع رقم، صفر فأكثر',
    'import.problem.invoicing.item.purchase_price': 'سعر الشراء رقم، صفر فأكثر',
    'import.problem.invoicing.item.sales_tax_code_id': 'رمز ضريبة البيع رمز قيمة مضافة مستعمل، لا رمز ضريبة استقطاع',
    'import.problem.invoicing.item.purchase_tax_code_id': 'رمز ضريبة الشراء رمز قيمة مضافة مستعمل، لا رمز ضريبة استقطاع',
    'import.problem.invoicing.item.income_account_id': 'حساب البيع حساب إيراد مستعمل',
    'import.problem.invoicing.item.expense_account_id': 'حساب الشراء حساب مستعمل',
    'change.field.item.import_id': 'مستورد من ملف',
    'change.field.entry.import_id': 'مستورد من ملف',
    // ── #95 ──
    'screen.accounting.opening.action.paste': 'لصق الأرصدة',
    'screen.accounting.opening.lede.file': 'تُرحَّل الأرصدة الافتتاحية قيدًا واحدًا متوازنًا في يومية عامة: من ملف (استيراد) يُفحص كل سطر فيه قبل أن يُرحَّل شيء، أو ملصوقةً نصًّا. والطرف المقابل عادةً حقوق الملكية، 300000 في الدليل المبدئي.',
    'screen.invoicing.bank_reconciliation.action.import.file': 'استيراد كشف',
    'screen.invoicing.bank_reconciliation.action.import.field.file': 'ملف كشف البنك',
    'screen.invoicing.bank_reconciliation.action.import.field.file.help': 'ملف CSV أو Excel (.xlsx) كما يصدّره البنك: تُعرف أعمدة التاريخ والمبلغ (أو المدين والدائن) والبيان بأسمائها، بالعربية أو الإنجليزية.',
    'screen.invoicing.bank_reconciliation.action.import.field.csv.paste': 'أو الصق أسطره (CSV)',
    'screen.invoicing.export_batches.action.download': 'تنزيل الملف',
    'screen.accounting.ledger.column.deferrable': 'قابل للتوزيع',
    'screen.accounting.ledger.action.defer': 'توزيع على أشهر',
    'screen.accounting.ledger.action.defer.field.months': 'على كم شهرًا',
    'screen.accounting.ledger.action.defer.field.months.help': 'حصة متساوية في آخر كل شهر، وما يبقى من الهللات على الشهر الأخير.',
    'screen.accounting.ledger.action.defer.field.deferral_account_id': 'يُحفظ في',
    'screen.accounting.ledger.action.defer.field.deferral_account_id.help': 'أصل لمصروف مدفوع مقدمًا، والتزام لإيراد مقبوض مقدمًا (إيراد مؤجل).',
    'screen.accounting.ledger.action.defer.field.starts_on': 'الشهر الأول',
    'screen.accounting.ledger.action.defer.field.starts_on.help': 'أي يوم في أول شهر يُثبت فيه. فارغًا: شهر القيد.',
    'screen.accounting.ledger.action.defer.field.reason': 'السبب',
    'screen.accounting.journal_book.title': 'دفتر اليومية',
    'screen.accounting.journal_book.lede': 'كل قيد مرحّل، سطرًا سطرًا، بترتيب ترحيله: باليوم ثم اليومية ثم الرقم. صفِّ يومية أو مدة، وصدِّره للمراجع.',
    'screen.accounting.journal_book.column.journal': 'اليومية',
    'screen.accounting.journal_book.column.journal_name': 'اسم اليومية',
    'screen.accounting.journal_book.journal': '{journal_code} · {journal_name}',
    'nav.accounting.journal_book': 'دفتر اليومية',
    'import.problem.accounting.account_unknown': 'لا حساب مستعملًا بالرمز {code}',
    'import.problem.accounting.one_side': 'لكل سطر مبلغ في المدين أو في الدائن — لا في كليهما ولا في أيٍّ منهما',
    'import.problem.accounting.one_date': 'القيد الافتتاحي في يوم واحد، والملف يذكر {n} أيام',
    'import.problem.accounting.two_lines': 'يحتاج القيد الافتتاحي سطرين على الأقل',
    'import.problem.accounting.unbalanced': 'الملف غير متوازن: المدين {debit} والدائن {credit}',
    'import.problem.accounting.one_journal': 'يُرحَّل القيد الافتتاحي في يومية واحدة، والملف يذكر أكثر من يومية',
    'import.problem.accounting.journal_unknown': 'لا يومية مستعملة بالرمز {code}',
    'import.problem.accounting.journal_general': 'تُرحَّل الأرصدة الافتتاحية في يومية عامة فقط',
    'import.problem.accounting.journal_choose': 'اذكر اليومية العامة في عمود اليومية: ليس في مساحة العمل يومية عامة، أو فيها أكثر من واحدة',
    'import.problem.accounting.no_period': 'لا فترة تشمل {date}',
    'import.problem.accounting.period_closed': 'فترة {date} مقفلة',
    'import.problem.accounting.locked': '{date} في تاريخ القفل أو قبله',
    // ── #87 · #90 ──
    'editor.vendor.supplierRef': 'رقم فاتورة المورد',
    'editor.vendor.supplierRefHint': 'كما هو مطبوع على فاتورته: به يسمّيها كشف حسابه وأي مراجعة.',
    'editor.vendor.twins': 'لهذا المورد فاتورة أخرى برقم {ref}:',
    'editor.vendor.twinDraft': 'مسودة',
    'editor.vendor.asWritten': 'كما كتبها المورد',
    'editor.vendor.asWrittenLede': 'خصم منحه على الفاتورة كلها، والضريبة لكل نسبة كما تذكرها فاتورته. ضريبة تختلف عن البنود بهللات (±1.00 للنسبة) تُحفظ كما كتبها، ويُرحَّل الفرق إلى حساب التقريب.',
    'editor.vendor.documentDiscountHint': 'يُخصم من الفاتورة كلها، وتنقص ضريبتها معه، ويُرحَّل إلى حساب الخصم المكتسب.',
    'editor.vendor.vatAtRate': 'الضريبة بنسبة {rate}٪',
    'editor.vendor.vatSame': 'كما تحسبها البنود',
    'editor.vendor.vatDiffers': 'تعطي البنود {computed}: {diff} إلى حساب التقريب',
    'editor.vendor.vatTooFar': 'لا تختلف الضريبة بنسبة {rate}٪ عن {computed} التي تحسبها البنود بأكثر من 1.00: راجع البنود.',
    'editor.need.supplierRef': 'رقم فاتورة المورد',
    'editor.need.vatAsWritten': 'ضريبة {rate}٪ في حدود 1.00 من البنود',
    'editor.files.title': 'الملفات',
    'editor.files.lede': 'فاتورة المورد، إذن التسليم: تُحفظ مع المستند. ويُفتح ملف PDF أو صورة بجانب النموذج.',
    'editor.files.choose': 'إرفاق ملف',
    'editor.files.open': 'فتح',
    'editor.files.close': 'إغلاق',
    'editor.files.waiting': 'يُضاف {name} حين تُحفظ المسودة',
    'invoicing.problem.supplier_ref': 'رقم فاتورة المورد مطلوب لإصدار فاتورة المورد',
    'screen.invoicing.vendor_bill.column.supplier_ref': 'رقم المورد',
    'screen.invoicing.vendor_bill.column.tax_adjustment': 'فرق الضريبة (كما كُتبت)',
    'screen.invoicing.vendor_bill.column.supplier_ref_twin': 'الرقم نفسه في فاتورة أخرى',
    'screen.invoicing.vendor_bill.column.vat_as_written': 'الضريبة كما كُتبت',
    'screen.invoicing.vendor_bill.alert.supplier_ref_twin': 'لهذا المورد فاتورة أخرى تحمل الرقم {supplier_ref}: هل أُدخلت هذه مرتين؟',
    'screen.invoicing.vendor_bill.alert.vat_as_written': 'الضريبة كما كتبها المورد: فرق {tax_adjustment} عن البنود رُحِّل إلى حساب التقريب',
    'screen.invoicing.settings.action.set.field.purchase_discount_account_id': 'حساب الخصم المكتسب',
    'screen.invoicing.settings.action.set.field.purchase_discount_account_id.help': 'حيث يُرحَّل خصم يمنحه المورد على الفاتورة كلها، وتنقص ضريبتها معه.',
    'screen.invoicing.settings.action.set.field.rounding_account_id': 'حساب التقريب',
    'screen.invoicing.settings.action.set.field.rounding_account_id.help': 'حيث تُرحَّل الهللات حين تُدخل ضريبة فاتورة المورد كما كتبها لا كما تحسبها بنودها (±1.00 للنسبة).',
    'change.field.document.supplier_ref': 'رقم المورد',
    'change.field.document.tax_adjustments': 'الضريبة لكل نسبة كما كُتبت',
    'change.field.document.tax_adjustment': 'فرق الضريبة (كما كُتبت)',
    'change.field.invoicing_settings.rounding_account_id': 'حساب التقريب',
    'change.field.invoicing_settings.purchase_discount_account_id': 'حساب الخصم المكتسب',
    // ── #88 ──
    'editor.line.party': 'الطرف',
    'editor.line.narration': 'بيان السطر',
    'editor.choices.dimensions': 'مراكز التكلفة',
    'editor.template.start': 'البدء من قالب',
    'editor.template.startHint': 'يومية القالب وبيانه وأسطره: بمبالغها، أو بحساباتها لتضع أنت المبالغ.',
    'editor.template.none': 'بلا قالب',
    'editor.template.withAmounts': 'بالمبالغ',
    'editor.template.accountsOnly': 'الحسابات فقط',
    'editor.template.keep': 'الحفظ قالبًا',
    'editor.template.keepLede': 'يومية هذا القيد وبيانه وأسطره، ليُكتب مرة أخرى: بمبالغه، أو بحساباته فقط.',
    'editor.template.name': 'اسم القالب',
    'editor.template.keepAction': 'حفظ القالب',
    'editor.template.kept': 'حُفظ باسم «{name}»: ابدأ القيد التالي منه في الأعلى.',
    'screen.accounting.entry_templates.title': 'قوالب القيود',
    'screen.accounting.entry_templates.lede': 'قيود محفوظة لتُكتب مرة أخرى: بمبالغها أو بحساباتها فقط. ابدأ منها في محرر القيد، واحفظها منه كذلك.',
    'screen.accounting.entry_templates.column.name_ar': 'الاسم',
    'screen.accounting.entry_templates.column.with_amounts': 'بالمبالغ',
    'screen.accounting.entry_templates.column.line_count': 'الأسطر',
    'screen.accounting.entry_templates.column.created_at': 'حُفظ',
    'screen.accounting.entry_templates.action.create': 'قيد جديد',
    'screen.accounting.entry_templates.action.retire': 'إيقاف',
    'screen.accounting.by_dimension.title': 'حسب مركز التكلفة',
    'screen.accounting.by_dimension.lede': 'ميزان المراجعة وقائمة الدخل حسب مركز التكلفة أو المشروع أو أي بُعد، مجموعةً بالشهر والقيمة والحساب.',
    'screen.accounting.by_dimension.column.month': 'الشهر',
    'screen.accounting.by_dimension.column.dimension_name': 'البُعد',
    'screen.accounting.by_dimension.column.value_name': 'القيمة',
    'screen.accounting.by_dimension.column.value_code': 'رمز القيمة',
    'screen.accounting.by_dimension.column.presentation': 'القائمة',
    'screen.accounting.by_dimension.column.result': 'أثره على النتيجة',
    'screen.accounting.by_dimension.value': '{value_code} · {value_name}',
    'nav.accounting.by_dimension': 'حسب مركز التكلفة',
    'nav.accounting.entry_templates': 'قوالب القيود',
    'change.field.document.dimension_id': 'البُعد',
    'change.field.document.value_id': 'مركز التكلفة',
    'change.field.entry_template.name_ar': 'الاسم',
    'change.field.entry_template.name_en': 'الاسم (بالإنجليزية)',
    'change.field.entry_template.journal_id': 'اليومية',
    'change.field.entry_template.narration_ar': 'البيان',
    'change.field.entry_template.with_amounts': 'بالمبالغ',
    'change.field.entry_template.lines': 'الأسطر',
    'change.field.entry_template.created_by': 'حفظه',
    'change.field.entry_template.retired_at': 'أُوقف',
    // ── #92 ──
    'editor.bank.file': 'ملف كشف البنك',
    'editor.bank.fileHint': 'ملف CSV أو Excel (.xlsx) كما يصدّره بنكك؛ تُعرف أعمدته بأسمائها بالعربية أو الإنجليزية.',
    'editor.bank.chooseFile': 'اختر الكشف',
    'editor.bank.paste': 'أو الصق أسطره (CSV)',
    'editor.bank.lineMatched': 'مطابق',
    'editor.bank.lineLeft': 'بقي {left} للمطابقة',
    'editor.bank.ruleSays': 'القاعدة «{rule}» تنسب هذا السطر إلى {account}.',
    'editor.bank.items': 'المطابقة بقيود الدفاتر',
    'editor.bank.itemsLede': 'اختر قيدًا أو أكثر، كله أو بعضه، حتى يبلغ {left}.',
    'editor.bank.noItems': 'لا قيد مفتوح في الدفاتر بهذا الاتجاه على هذا الحساب.',
    'editor.bank.partAmount': 'المبلغ المطابق',
    'editor.bank.gap': 'المختار {chosen} من {left}: يبقى {gap}',
    'editor.bank.differenceAccount': 'إقفال الفرق إلى',
    'editor.bank.differenceHint': 'يُقفل السطر عند الصفر، أو بترحيل الباقي إلى حساب — صراحةً ومع سببه.',
    'editor.bank.reason': 'السبب',
    'editor.bank.matchItems': 'مطابقة',
    'editor.bank.matchWithDifference': 'مطابقة وترحيل الفرق',
    'editor.bank.closed': 'طوبق السطر.',
    'editor.bank.partial': 'طوبق جزئيًا: ما بقي من السطر ما زال مفتوحًا.',
    'editor.bank.book': 'ترحيل إلى حساب',
    'editor.bank.bookLede': 'ما لا يفسّره قيد — رسوم، مصروف، إيراد: {left} يُرحَّل مقابل الحساب المختار.',
    'editor.bank.account': 'الحساب',
    'editor.bank.bookAction': 'ترحيل السطر',
    'editor.bank.booked': 'رُحِّل السطر وطوبق.',
    'editor.bank.receipt': 'سند قبض من عميل',
    'editor.bank.payment': 'سند صرف لمورد',
    'editor.bank.paymentLede': 'سند بمبلغ {left} عبر هذا البنك في يوم السطر، يُطابق بالسطر في الخطوة نفسها. وزّعه على المستندات من صفحته.',
    'editor.bank.party': 'الطرف',
    'editor.bank.makeReceipt': 'إنشاء سند القبض',
    'editor.bank.makePayment': 'إنشاء سند الصرف',
    'editor.bank.paymentMade': 'أُنشئ السند وطوبق السطر.',
    'editor.bank.unmatch': 'التراجع عن المطابقة',
    'editor.bank.unmatchAction': 'تراجع',
    'editor.bank.unmatched': 'تم التراجع: عاد السطر وقيوده مفتوحة.',
    'editor.bank.lastUnmatched': 'آخر تراجع كان لأن: {reason}',
    'screen.invoicing.bank.unmatch.field.reason': 'السبب',
    'screen.invoicing.bank_rules.title': 'قواعد المطابقة البنكية',
    'screen.invoicing.bank_rules.lede': 'سطر الكشف الذي يوافق قاعدةً بكلماته ومبلغه واتجاهه يُعطى حسابها، مقترحًا أو مرحّلًا عند الاستيراد، والأسبق أولويةً يغلب.',
    'screen.invoicing.bank_rules.column.priority': 'الأولوية',
    'screen.invoicing.bank_rules.column.name_ar': 'القاعدة',
    'screen.invoicing.bank_rules.column.narration_contains': 'تتضمن الكلمات',
    'screen.invoicing.bank_rules.column.direction': 'الاتجاه',
    'screen.invoicing.bank_rules.column.amount_min': 'من',
    'screen.invoicing.bank_rules.column.amount_max': 'إلى',
    'screen.invoicing.bank_rules.column.account_name': 'الحساب',
    'screen.invoicing.bank_rules.column.journal_code': 'البنك',
    'screen.invoicing.bank_rules.column.mode': 'النمط',
    'screen.invoicing.bank_rules.action.create': 'قاعدة جديدة',
    'screen.invoicing.bank_rules.action.retire': 'إيقاف',
    'screen.invoicing.bank_rules.action.create.field.name_ar': 'الاسم',
    'screen.invoicing.bank_rules.action.create.field.narration_contains': 'تتضمن كلمات السطر',
    'screen.invoicing.bank_rules.action.create.field.narration_contains.help': 'كما يكتبها البنك، مثل «رسوم» أو «SADAD»، بلا اعتبار لحالة الأحرف.',
    'screen.invoicing.bank_rules.action.create.field.direction': 'الاتجاه',
    'screen.invoicing.bank_rules.action.create.field.amount_min': 'المبلغ من',
    'screen.invoicing.bank_rules.action.create.field.amount_max': 'المبلغ إلى',
    'screen.invoicing.bank_rules.action.create.field.account_id': 'الحساب',
    'screen.invoicing.bank_rules.action.create.field.account_id.help': 'حيث يُرحَّل السطر الذي توافقه القاعدة: رسوم بنكية، مصروف، إيراد، حساب تحويل.',
    'screen.invoicing.bank_rules.action.create.field.mode': 'النمط',
    'screen.invoicing.bank_rules.action.create.field.mode.help': 'الاقتراح يعرض الحساب على السطر؛ والتطبيق يرحّل السطر إليه حين يُستورد الكشف.',
    'screen.invoicing.bank_rules.action.create.field.priority': 'الأولوية',
    'screen.invoicing.bank_rules.action.create.field.priority.help': 'الأصغر أولًا حين توافق قاعدتان سطرًا واحدًا.',
    'value.bank_rule_direction.any': 'أيّ اتجاه',
    'value.bank_rule_direction.in': 'وارد',
    'value.bank_rule_direction.out': 'صادر',
    'value.bank_rule_mode.suggest': 'اقتراح',
    'value.bank_rule_mode.apply': 'تطبيق',
    'nav.invoicing.bank_rules': 'قواعد المطابقة البنكية',
    'change.field.bank_statement.unmatch_reason': 'سبب التراجع',
    'change.field.bank_statement.line_id': 'سطر الكشف',
    'change.field.bank_statement.item_id': 'القيد المطابق',
    'change.field.bank_statement.matched_by': 'طابقه',
    'change.field.bank_statement.unmatched_by': 'تراجع عنه',
    'change.field.bank_statement.unmatched_at': 'تاريخ التراجع',
    'change.field.bank_rule.name_ar': 'الاسم',
    'change.field.bank_rule.journal_id': 'البنك',
    'change.field.bank_rule.direction': 'الاتجاه',
    'change.field.bank_rule.narration_contains': 'تتضمن الكلمات',
    'change.field.bank_rule.amount_min': 'المبلغ من',
    'change.field.bank_rule.amount_max': 'المبلغ إلى',
    'change.field.bank_rule.account_id': 'الحساب',
    'change.field.bank_rule.party_id': 'الطرف',
    'change.field.bank_rule.mode': 'النمط',
    'change.field.bank_rule.priority': 'الأولوية',
    'change.field.bank_rule.created_by': 'أنشأها',
    'change.field.bank_rule.retired_at': 'أُوقفت',
    // ── list pages: what an empty list means (list-standard §11, R6) ──
    'screen.accounting.accounts.empty': 'لا حسابات في الدليل بعد',
    'screen.accounting.accounts.empty.description': 'أضف حسابًا، أو استورد الدليل الابتدائي لتبدأ منه.',
    'screen.accounting.dimension_values.empty': 'لا قيم للأبعاد بعد',
    'screen.accounting.dimension_values.empty.description': 'كل قيمة يُوسم بها السطر — مركز تكلفة أو مشروع — تظهر هنا تحت بُعدها.',
    'screen.accounting.dimensions.empty': 'لا أبعاد بعد',
    'screen.accounting.dimensions.empty.description': 'البُعد، كمركز التكلفة أو المشروع، يَسِم السطور المرحّلة لتُقرأ التقارير به.',
    'screen.accounting.entries.empty': 'لا قيود يومية بعد',
    'screen.accounting.entries.empty.description': 'كل قيد مرحّل يظهر هنا برقمه وتاريخه وبيانه.',
    'screen.accounting.entry_templates.empty': 'لا قوالب قيود بعد',
    'screen.accounting.entry_templates.empty.description': 'احفظ القيد قالبًا من محرّر القيد لتكتبه مرة أخرى.',
    'screen.accounting.fiscal_years.empty': 'لا سنوات مالية بعد',
    'screen.accounting.fiscal_years.empty.description': 'أنشئ السنة المالية أولًا، ثم تُضاف فتراتها تحتها.',
    'screen.accounting.journals.empty': 'لا دفاتر يومية بعد',
    'screen.accounting.journals.empty.description': 'كل دفتر يومية يرقّم قيوده: مبيعات أو مشتريات أو بنك أو نقدية أو عام.',
    'screen.accounting.periods.empty': 'لا فترات بعد',
    'screen.accounting.periods.empty.description': 'يجد الترحيل فترته بتاريخه، فكل يوم من السنة المالية يقع في فترة واحدة.',
    'screen.accounting.posting_rules.empty': 'لا قواعد ترحيل بعد',
    'screen.accounting.posting_rules.empty.description': 'القاعدة تسمّي الحسابين المدين والدائن اللذين يُرحَّل إليهما نوعٌ من السطور.',
    'screen.accounting.tax_codes.empty': 'لا رموز ضريبة بعد',
    'screen.accounting.tax_codes.empty.description': 'استورد حزمة ضريبة القيمة المضافة أو أضف رمزًا، ويُفعَّل كلٌّ منها حين يؤكّده شخص مسمّى.',
    'screen.accounting.tax_rules.empty': 'لا قواعد ضريبة بعد',
    'screen.accounting.tax_rules.empty.description': 'القاعدة تختار رمز الضريبة للسطر بحسب نوعه والمشتري ووجهة التوريد.',
    'screen.einvoicing.devices.empty': 'لا وحدات حلول تقنية بعد',
    'screen.einvoicing.devices.empty.description': 'كل وحدة حل تقني توقّع فواتير فرعٍ ودفتر مبيعات واحد وترقّمها بعد ربطها بالهيئة.',
    'screen.einvoicing.sellers.empty': 'لا بيانات منشأة بائعة بعد',
    'screen.einvoicing.sellers.empty.description': 'المنشأة البائعة التي تسمّيها كل فاتورة إلكترونية: اسمها النظامي ورقمها الضريبي وسجلّها التجاري وعنوانها الوطني، لكل فرع.',
    'screen.invoicing.bank_rules.empty': 'لا قواعد مطابقة بعد',
    'screen.invoicing.bank_rules.empty.description': 'القاعدة تعطي سطر الكشف المتكرر — رسوم بنك أو إيجار — حسابه دون مطابقته يدويًا.',
};
//# sourceMappingURL=i18n-accounting-work.js.map